export enum AlertTheme {
  SUCCESS = "Success",
  ERROR = "Error",
}
